var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.513746 0.697375C0.761246 0.413375 1.16251 0.413375 1.41002 0.697375L6.66568 6.72859L11.9214 0.697375C12.1688 0.413375 12.5701 0.413375 12.8176 0.697375C13.0651 0.981376 13.0651 1.44189 12.8176 1.72589L7.11381 8.27136C6.86633 8.55538 6.46503 8.55538 6.21755 8.27136L0.513746 1.72589C0.266251 1.44189 0.266251 0.981376 0.513746 0.697375Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVVector);
export default __webpack_public_path__ + "static/media/v-vector.4188fc5b56e58f77a1f6b397a4c9f17c.svg";
export { ForwardRef as ReactComponent };